import { render } from "./ButtonBasic.vue?vue&type=template&id=04575312"
import script from "./ButtonBasic.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ButtonBasic.vue?vue&type=script&charset=utf-8&lang=js"

import "./ButtonBasic.vue?vue&type=style&index=0&id=04575312&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__